import * as elementReducers from './reducers/index';
import reduceReducers from 'reduce-reducers';

export default reduceReducers(
  elementReducers.elementLayout,
  elementReducers.mobileElement,
  elementReducers.desktopElement,
  elementReducers.previewElement,
  elementReducers.elementProps,
  elementReducers.alignElements,
);
